import { writable } from "svelte/store";

export const isAuth = writable("loading");
export const userData = writable({
  access_level: 0
})

// Checking is checkout method card
export const isCard = writable(false);